import { useLocation } from "react-router";
import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";

export type CoApplicantProductType = "personal_loans" | "credit_cards" | "vehicle_loans";

const PRODUCT_TYPE_MAP: Record<string, CoApplicantProductType> = {
  "personal-loan": "personal_loans",
  "olb-personal-loan": "personal_loans",
  "credit-card": "credit_cards",
  "olb-credit-card": "credit_cards",
  "auto-loan": "vehicle_loans",
  "olb-auto-loan": "vehicle_loans",
};

/** Convert a lending route product segment to its institution-settings key. */
export function getCoApplicantProductType(productType: string): CoApplicantProductType | undefined {
  return PRODUCT_TYPE_MAP[productType];
}

export function useIsCoApplicantEnabled(productType?: CoApplicantProductType): boolean {
  const { institution } = useGetInstitutionQuery();
  // Router location, not window.location: when a host mounts lending under a basename the
  // latter still carries the mount prefix, which would shift every segment index.
  const location = useLocation();

  let typeToCheck: CoApplicantProductType | undefined = productType;

  // If no product type is provided, derive it from the URL
  if (!typeToCheck) {
    const firstPathSegment = location.pathname.split("/")[1];
    typeToCheck = getCoApplicantProductType(firstPathSegment);
  }

  if (!typeToCheck) {
    return false;
  }

  return institution.lending_co_applicants_enabled_products.includes(typeToCheck);
}
